// ** React Imports

// ** Third Party Components
import * as yup from "yup"
import { useFormik } from "formik"
// import { useAsesoria } from "@hooks/useAsesoria"

// ** Reactstrap Imports
import {
  //  Form,
  FormFeedback,
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap"
import Select from "react-select"
import { useEffect, useState } from "react"
import CustomSpinner from "../../../../components/spinners/CustomSpinner"

// ** Styles

const RetiroInteligenteForm = (props) => {
  // ** State
  const [isOpen, setIsOpen] = useState(false)
  const catalogoMonedas = [
    {
      label: "MXN",
      value: "MXN"
    },
    {
      label: "USD",
      value: "USD"
    },
    {
      label: "CAD",
      value: "CAD"
    },
    {
      label: "EUR",
      value: "EUR"
    }
  ]

  const validationSchema = () => {
    return yup.object({
    })
  }

  function onClickCalcular() {
    setIsOpen(true)
  }

  function initialValues() {
    if (props.accion === 1) {
      return {
        nombreProspecto: "",
        edadRetirarte: "",
        monedaRetiro: "MXN",
        rentaRetiro: "",
        expectativaVida: "",
        edad: "",
        ahorroHoy: "",
        regimenFiscal: ""
      }
    } else {
      return props.data
    }
  }

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    onSubmit: (data, { resetForm }) => {
      data = {
        ...data,
        accion: props.accion,
        tipo: "personal",
        nombre: "Retiro Inteligente",
        slug: "retiro-inteligente"
      }
      props.administrar(data, props.handleSuccess)
      resetForm()
    }
  })

  // Formulas Calculadora
  const totalFondo =
    parseFloat(formik.values.rentaRetiro) *
    12 *
    (parseFloat(formik.values.expectativaVida) -
      parseFloat(formik.values.edadRetirarte))
  const edadRestante =
    parseFloat(formik.values.edadRetirarte) - parseFloat(formik.values.edad)
  const totalReal = totalFondo - parseFloat(formik.values.ahorroHoy)
  const totalMes = totalReal / (edadRestante * 12)
  const total = parseFloat(totalMes.toFixed(2))
  const totalF = parseFloat(totalFondo.toFixed(2))

  return (
    <div>
      <Modal isOpen={isOpen}>
        <ModalHeader
          toggle={() => {
            setIsOpen(false)
          }}
        >
          Calculadora Retiro Inteligente
        </ModalHeader>
        <ModalBody>
          <span>
            Según tu edad deberas contar con un fondo de{" "}
            <span>
              {totalF} {formik.values.monedaRetiro}.
            </span>
          </span>
          <span>
            Para poderte retirar a la edad de:{" "}
            <span>{formik.values.edadRetirarte} años</span> con un monto mensual
            de{" "}
            <span>
              {formik.values.rentaRetiro} {formik.values.monedaRetiro}.{" "}
            </span>{" "}
          </span>
          <span>
            Esto siginifica que en los <span>{edadRestante} años</span> que te
            quedan para ahorrar es necesario que destines{" "}
            <span>
              {total} {formik.values.monedaRetiro}{" "}
            </span>{" "}
            al mes lograr este objetivo.{" "}
          </span>
        </ModalBody>
        <ModalFooter>
          <div className="d-flex justify-content-end">
            <Button onClick={formik.handleSubmit}>Guardar</Button>
          </div>
        </ModalFooter>
      </Modal>

      <Modal isOpen={props.loading}>
        <CustomSpinner />
      </Modal>
      <h1 className="mb-2 col-12 text-center">Retiro inteligente</h1>
      <div>
        <div className="mb-1">
          <Label className="form-label" for="tipo">
            Nombre completo
          </Label>
          <Input
            invalid={formik.errors.nombreProspecto && true}
            value={formik.values.nombreProspecto}
            onChange={(e) => {
              formik.setFieldValue("nombreProspecto", e.target.value)
            }}
          />
          {formik.errors.nombreProspecto && (
            <FormFeedback>{formik.errors.nombreProspecto}</FormFeedback>
          )}
        </div>
        <div className="mb-1">
          <Label className="form-label" for="tipo">
            ¿A que edad te gustaría retirarte?
          </Label>
          <Input
            type="number"
            invalid={formik.errors.edadRetirarte && true}
            value={formik.values.edadRetirarte}
            onChange={(e) => {
              formik.setFieldValue("edadRetirarte", e.target.value)
            }}
          />
          {formik.errors.edadRetirarte && (
            <FormFeedback>{formik.errors.edadRetirarte}</FormFeedback>
          )}
        </div>
        <div className="mb-1">
          <Label className="form-label" for="tipo">
            ¿En que moneda te gustaría ahorrar y recibir tu retiro?
          </Label>
          <Select
            className="react-select"
            classNamePrefix="select"
            defaultValue={catalogoMonedas[0]}
            value={{
              label: formik.values.monedaRetiro,
              value: formik.values.monedaRetiro
            }}
            options={catalogoMonedas}
            isClearable={false}
            onChange={(e) => {
              formik.setFieldValue("monedaRetiro", e.value)
            }}
          />
          {formik.errors.monedaRetiro && (
            <FormFeedback>{formik.errors.monedaRetiro}</FormFeedback>
          )}
        </div>
        <div className="mb-1">
          <Label className="form-label" for="tipo">
            ¿Con que renta mensual te gustaría retirarte?
          </Label>
          <Input
            type="number"
            invalid={formik.errors.rentaRetiro && true}
            value={formik.values.rentaRetiro}
            onChange={(e) => {
              formik.setFieldValue("rentaRetiro", e.target.value)
            }}
          />
          {formik.errors.rentaRetiro && (
            <FormFeedback>{formik.errors.rentaRetiro}</FormFeedback>
          )}
        </div>
        <div className="mb-1">
          <Label className="form-label" for="tipo">
            ¿Cuál es tu expectativa de vida?
          </Label>
          <Input
            type="number"
            invalid={formik.errors.expectativaVida && true}
            value={formik.values.expectativaVida}
            onChange={(e) => {
              formik.setFieldValue("expectativaVida", e.target.value)
            }}
          />
          {formik.errors.expectativaVida && (
            <FormFeedback>{formik.errors.expectativaVida}</FormFeedback>
          )}
        </div>
        <div className="mb-1">
          <Label className="form-label" for="tipo">
            ¿Qué edad tienes hoy en día?
          </Label>
          <Input
            type="number"
            invalid={formik.errors.edad && true}
            value={formik.values.edad}
            onChange={(e) => {
              formik.setFieldValue("edad", e.target.value)
            }}
          />
          {formik.errors.edad && (
            <FormFeedback>{formik.errors.edad}</FormFeedback>
          )}
        </div>
        <div className="mb-1">
          <Label className="form-label" for="tipo">
            ¿Cuánto tienes ahorrado para retiro hoy?
          </Label>
          <Input
            type="number"
            invalid={formik.errors.ahorroHoy && true}
            value={formik.values.ahorroHoy}
            onChange={(e) => {
              formik.setFieldValue("ahorroHoy", e.target.value)
            }}
          />
          {formik.errors.ahorroHoy && (
            <FormFeedback>{formik.errors.ahorroHoy}</FormFeedback>
          )}
        </div>
        <div className="mb-1">
          <Label className="form-label" for="tipo">
            ¿Cuál es tu régimen fiscal?
          </Label>
          <Input
            invalid={formik.errors.regimenFiscal && true}
            value={formik.values.regimenFiscal}
            onChange={(e) => {
              formik.setFieldValue("regimenFiscal", e.target.value)
            }}
          />
          {formik.errors.regimenFiscal && (
            <FormFeedback>{formik.errors.regimenFiscal}</FormFeedback>
          )}
        </div>
      </div>

      <div className="d-flex justify-content-end">
        <Button
          className="me-1"
          color="primary"
          onClick={() => {
            onClickCalcular()
          }}
        >
          {props.accion === 1 ? "Calcular retiro" : "Guardar cambios"}
        </Button>
      </div>
    </div>
  )
}

export default RetiroInteligenteForm
